<div id="dates_preview">
    
    <div id="dates_preview_title">{{'NB_MISSIONS_TOTAL' | translate}} <marv-circle>{{this.stats.global}}</marv-circle></div>
    
    <marv-tabs [tabs]="this.tabs">
        <marv-tab tabId="calendar">
            <div id="current_month">
                <marv-button id="btn_previous_month" icon="chevron-back-outline" [rounded]="true" [disabled]="this.disablePreviousMonth()" size="small" (click)="this.previousMonth()"/>
                <div id="current_month_infos">
                    <div id="current_month_label">
                        <ion-icon name="calendar-outline"></ion-icon>{{this.currentMonth | marvDateToString: 'MMMM YYYY'}}
                    </div> 
                </div>                            
                <marv-button id="btn_next_month" icon="chevron-forward-outline" [rounded]="true" [disabled]="this.disableNextMonth()" size="small" (click)="this.nextMonth()"/>
            </div>

            <div id="calendar_preview">
                <div id="calendar_header">
                    @for(wd of this.weekDays; track $index){
                        <div class="calendar_cell">{{wd.name}}</div>
                    }
                </div>
                <div id="calendar_content">
                    @for(w of this.weeks; track $index){
                        <div class="calendar_content_week">
                            @for(wd of this.weekDays; track $index){
                                <div class="calendar_cell" 
                                     [class.today]="!w[wd.numDay].otherMonth && !w[wd.numDay].publicHoliday && w[wd.numDay].today"
                                     [class.public_holiday]="!w[wd.numDay].otherMonth && w[wd.numDay].publicHoliday"
                                     [class.other_month]="w[wd.numDay].otherMonth"
                                     [class.with_events]="!w[wd.numDay].otherMonth && (w[wd.numDay].day.nbEvents > 0 || this.addedDates.has(w[wd.numDay].day.dateStr))"
                                     [class.deleted_date]="!w[wd.numDay].otherMonth && this.deletedDates.has(w[wd.numDay].day.dateStr)"                                     
                                     [class.disabled_date]="!w[wd.numDay].otherMonth && w[wd.numDay].day.disabled"                                     
                                     >
                                    @if(!w[wd.numDay].otherMonth){
                                    
                                        {{w[wd.numDay].day.date | marvDateToString: 'DD'}}
                                        
                                        @if(this.editable){                                        
                                            @if((w[wd.numDay].day.nbEvents > 0 || this.addedDates.has(w[wd.numDay].day.dateStr)) && !this.deletedDates.has(w[wd.numDay].day.dateStr)){
                                                <div class="btn_delete_date" (click)="this.deleteDate(w[wd.numDay].day)"><ion-icon name="close-outline"></ion-icon></div>
                                            } 
                                            @else if(!w[wd.numDay].day.disabled){
                                                <div class="btn_add_date" (click)="this.addDate(w[wd.numDay].day)"></div>
                                            }
                                        }
                                                                                
                                        @if(this.deletedDates.has(w[wd.numDay].day.dateStr)){
                                            <div class="delete_date_preview"></div>
                                        }
                                        
                                    }                                    
                                </div>                        
                            }
                        </div>
                    }
                </div>
            </div>

            <div id="summary_days">
                <div id="summary_days_header" class="row_stats">{{'NB_MISSIONS_MONTH' | translate}} <marv-circle size="small">{{this.stats.globalMonth}}</marv-circle></div>
                @for(s of this.stats.weekDays; track $index){
                    <div class="row_stats">{{s.day | marvDateToString: 'dddd'}} <marv-circle size="small">{{s.nbEvents}}</marv-circle></div>
                }
            </div>
        </marv-tab>
        <marv-tab tabId="list">
            <div id="dates_list">
                @for(m of this.months; track $index){
                    <div class="month">
                        <div class="month_title">{{m.month | marvDateToString: 'MMMM YYYY'}} <marv-circle size="small">{{m.days.length}}</marv-circle></div>
                        <div class="month_dates">
                            @for(s of m.days; track $index){
                                <div class="month_date" [class.deleted_date]="this.deletedDates.has(s.dateStr)">
                                    {{s.date | marvDateToString: 'ddd DD/MM/YYYY'}}
                                    @if(this.editable && !this.deletedDates.has(s.dateStr)){
                                        <ion-icon name="close-outline" (click)="this.deleteDate(s)"></ion-icon>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </marv-tab>
    </marv-tabs>
    
    @if(this.editable){
        <ion-grid id="dates_preview_actions">
            <ion-row class="ion-justify-content-around">
                <ion-col size="auto">
                    <marv-button type="button" label="{{ 'VALIDATE' | translate }}" icon="checkmark-outline" color="primary" (click)="this.validateDates()" />
                </ion-col>
                <ion-col size="auto">
                    <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
                </ion-col>
            </ion-row>
        </ion-grid>
    }
    
</div>